module.exports = __webpack_public_path__ + "img/support.21806789.svg";